<template>
  <v-container class="page-content px-5" style="width: 100%">
    <OrderDetail
        v-if="this.loading"
        :item="item"
    >
      <template v-slot:btn>
        <v-btn
            @click="returnParent()" class="dark-primary pr-0 mr-0" icon small
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly && item.is_formalized && item.is_agreed === null"
            icon
            class="mr-0 dark-primary"
            @click="editOrder"
        >
          <v-icon>sync_alt</v-icon>
        </v-btn>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly && item.is_agreed && item.order_type==='Массовый'"
            icon
            class="mr-0 dark-primary"
            @click="orderVisitors(item)"
        >
          <v-icon>group</v-icon>
        </v-btn>
        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
          <v-btn
              v-if="$vuetify.breakpoint.smAndUp && item.is_formalized && item.is_agreed === null"
              depressed
              outlined
              @click="editOrder"
              class="rounded-tr-lg dark-primary"
          >
            Изменить статус заявки
          </v-btn>
          <v-btn
              v-if="$vuetify.breakpoint.smAndUp && item.is_agreed && item.order_type==='Массовый'"
              depressed
              outlined
              @click="orderVisitors(item)"
          >
            Изменить посетителей заявки
          </v-btn>
        </v-toolbar-items>
      </template>
    </OrderDetail>
    <v-skeleton-loader
        v-else
        type="table-heading, list-item-three-line, image, list-item-two-line, table-tfoot"
    ></v-skeleton-loader>
    <OrdersDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :order-data="order_data"
        @close="closeEditDialog"
    ></OrdersDialog>
    <OrdersVisitorsDialog
        v-if="dialog_add_visitor"
        :opened="dialog_add_visitor"
        :order-data="order_data"
        @close="closeVisitorDialog"
    ></OrdersVisitorsDialog>
  </v-container>
</template>

<script>
import TitledPageMixin from "@/mixins/TitledPageMixin";
import {mapActions, mapGetters} from "vuex";
import names from "@/modules/entitled/routers/names";
import OrderDetail from "@/modules/templates/OrderDetail";
import OrdersDialog from "../components/OrdersEditDialog";
import OrdersVisitorsDialog from "@/modules/entitled/orders/components/OrdersVisitorsDialog";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";

export default {
  name: "EntitledOrdersDetail",
  mixins: [TitledPageMixin],
  components: {OrderDetail, OrdersDialog, OrdersVisitorsDialog},
  data() {
    return {
      loading: false,
      page_title: "Детальное представление заявки",
      dialog_add_edit: false,
      dialog_add_visitor: false,
      edit_status: undefined,
      order_data: undefined
    }
  },
  computed: {
    ...mapGetters({
      item: "entitled/getOrdersDetail"
    })
  },
  methods: {
    ...mapActions({
      loadOrderDetail: "entitled/loadOrdersDetail"
    }),
    returnParent() {
      this.$router.push({name: names.ORDERS.LIST}).catch(() => {})
    },
    editOrder() {
      this.dialog_add_edit = true
      this.edit_status = true
      this.order_data = this.item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.order_data = undefined
    },
    orderVisitors(item) {
      this.dialog_add_visitor = true
      this.order_data = item
    },
    closeVisitorDialog(event) {
      this.loadData()
      this.dialog_add_visitor = false
      this.order_data = undefined
    },
    loadData(url=undefined){
      this.loadOrderDetail({
        url: url,
        id: this.$route.params.idOrders,
        finalizer: (data) => {
          if (data.through_number === null) {
            this.page_title = "Черновик заявки"
          } else {
            this.page_title = "Заявка: " + data.through_number
          }
          this.loading = true
        }
      })
    }
  },
  created () {
    if(entitled.ENTITLED.ALLOWED()) {
      this.loadData(undefined)
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
